export default {
  navText: 'Navbar',
};
